// extracted by mini-css-extract-plugin
export var filterIncDec = "_ec-0";
export var leftBorder = "_ec-1";
export var rightBorder = "_ec-2";
export var stringInput = "_ec-3";